import { allocationAPI } from 'api/AllocationAPI'

/**
 * Adapts `allocationAPI` to the generic `api` shape expected by the
 * `newWithEditModal` HOC (`create(cvId, item)` / `delete(id, cvId?)`).
 *
 * `AllocationModal` is always used with `submitOnModal`, so the HOC never
 * actually calls `create` itself - only `delete` (via the HOC's built-in
 * delete confirmation) is exercised at runtime.
 *
 * @notExported
 */
export const allocationModalApi = {
  create: (_cvId: number, item: unknown) => allocationAPI.create(item),
  delete: (id: number) => allocationAPI.delete(id).then(() => undefined),
}
